import { __decorate } from 'tslib';
import { Subject, ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { Service } from '../../decorators/class/service.js';

/**
 * 基于 rxjs 的通知中心
 * @public
 */
let EventEmitter = class EventEmitter {
    constructor() {
        this.subjects = {};
    }
    createIfNotExist(eventName, subject = new Subject()) {
        if (!this.subjects[eventName]) {
            this.subjects[eventName] = subject;
        }
        return this.subjects[eventName];
    }
    /**
     * 监听 Workbench 事件
     *
     * @param eventName - 事件名称
     * @param handler - 回调方法
     */
    listen(eventName, handler) {
        this.createIfNotExist(eventName);
        return this.subjects[eventName].subscribe(handler);
    }
    /**
     * 监听 Workbench 事件，只接收一次事件
     *
     * @param eventName - 事件名称
     * @param handler - 回调方法
     */
    listenOnce(eventName, handler) {
        this.createIfNotExist(eventName);
        return this.subjects[eventName].pipe(first()).subscribe(handler);
    }
    /**
     * 抛出 Workbench 事件
     *
     * @param eventName - 事件名称
     * @param payload - 携带参数对象
     */
    emit(eventName, payload) {
        this.createIfNotExist(eventName);
        this.subjects[eventName].next(payload);
    }
    /**
     * 抛出 Workbench 事件，监听方即使在事件抛出后才开始监听，也能接收到事件
     * @param eventName - 事件名称
     * @param payload - 携带参数对象
     */
    emitReplay(eventName, payload) {
        this.createIfNotExist(eventName, new ReplaySubject(1));
        this.subjects[eventName].next(payload);
    }
    /**
     * 销毁所有监听器
     *
     */
    dispose() {
        Object.keys(this.subjects).forEach((eventName) => {
            const subscription = this.subjects[eventName];
            subscription.complete();
            subscription.unsubscribe();
            delete this.subjects[eventName];
        });
    }
};
EventEmitter = __decorate([
    Service()
], EventEmitter);

export { EventEmitter };
//# sourceMappingURL=event-emitter.js.map
